import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Grid = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 28H21C19.35 28 18 26.65 18 25V21C18 19.35 19.35 18 21 18H25C26.65 18 28 19.35 28 21V25C28 26.65 26.65 28 25 28ZM21 20C20.45 20 20 20.45 20 21V25C20 25.55 20.45 26 21 26H25C25.55 26 26 25.55 26 25V21C26 20.45 25.55 20 25 20H21Z" />
		<path d="M11 28H7C5.35 28 4 26.65 4 25V21C4 19.35 5.35 18 7 18H11C12.65 18 14 19.35 14 21V25C14 26.65 12.65 28 11 28ZM7 20C6.45 20 6 20.45 6 21V25C6 25.55 6.45 26 7 26H11C11.55 26 12 25.55 12 25V21C12 20.45 11.55 20 11 20H7Z" />
		<path d="M25 14H21C19.35 14 18 12.65 18 11V7C18 5.35 19.35 4 21 4H25C26.65 4 28 5.35 28 7V11C28 12.65 26.65 14 25 14ZM21 6C20.45 6 20 6.45 20 7V11C20 11.55 20.45 12 21 12H25C25.55 12 26 11.55 26 11V7C26 6.45 25.55 6 25 6H21Z" />
		<path d="M11 14H7C5.35 14 4 12.65 4 11V7C4 5.35 5.35 4 7 4H11C12.65 4 14 5.35 14 7V11C14 12.65 12.65 14 11 14ZM7 6C6.45 6 6 6.45 6 7V11C6 11.55 6.45 12 7 12H11C11.55 12 12 11.55 12 11V7C12 6.45 11.55 6 11 6H7Z" />
	</svg>
);

export default Grid;
